/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ComponentProps, Dispatch } from "react";
import { When } from "react-if";
import { Row, Col, Box, FlexContainer, theme } from "@nordcloud/gnui";
import { ExpandIcon } from "~/components";
import {
  ApplicationItemDescription,
  ApplicationItemTotals,
  EnvironmentDetails,
} from "~/components/ApplicationItem";
import { useToggle } from "~/hooks";
import { hasCo2e } from "~/tools/applicationMapper";

type Props = {
  application: ComponentProps<typeof ApplicationItemTotals>["application"];
  setEditAppId?: Dispatch<boolean>;
  getAppHandler?: (options: {
    variables: { id: string; year: string };
  }) => void;
};

export function ApplicationItem({ application, getAppHandler }: Props) {
  const [isExpanded, toggleIsExpanded] = useToggle();

  const showAppCo2eSavings = hasCo2e(application);

  return (
    <Box spacing="spacing02" boxStyle="lightGrey">
      <Row>
        <Col sm={5} md={4} lg={7}>
          <FlexContainer>
            <ExpandIcon
              name="chevronDown"
              title="chevronDown"
              isExpanded={isExpanded}
              css={{
                marginRight: theme.spacing.spacing00,
              }}
              onClick={toggleIsExpanded}
            />
            <ApplicationItemDescription
              isEstateRecordPage
              application={application}
            />
          </FlexContainer>
        </Col>
        <ApplicationItemTotals
          application={application}
          getAppHandler={getAppHandler}
          showAppCo2eSavings={showAppCo2eSavings}
        />
      </Row>
      <When condition={isExpanded}>
        <EnvironmentDetails
          applicationId={application.id}
          environments={application.envs}
          showAppCo2eSavings={showAppCo2eSavings}
        />
      </When>
    </Box>
  );
}
